import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { DocumentService } from 'src/app/core/services/document.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';

@Component({
  selector: 'app-delete-candidate-document',
  templateUrl: './delete-candidate-document.component.html',
  styleUrls: ['./delete-candidate-document.component.css']
})
export class DeleteCandidateDocumentComponent implements OnInit {

  @Input() document: any;
  @Input() deleteDocumentPayload: any;
  @Input() candidateDetails: any;
  @Output() saveCallback = new EventEmitter<any>();
  @Output() cancelCallback = new EventEmitter<any>();

  MESSAGECONSTANTS: any = MESSAGECONSTANTS;

  savingFlag = false;
  deleteLatestVersion = true;

  constructor(
    private documentService: DocumentService,
    private alertsAndNotificationsService: AlertAndNotificationsService
  ) { }

  ngOnInit() {
    this.savingFlag = false;
    this.deleteLatestVersion = true;
  }

  delete() {
    this.savingFlag = true;
    this.deleteDocumentPayload.keepLastVersion = this.deleteLatestVersion;
    this.documentService.deleteCandidateDocument(this.deleteDocumentPayload, () => {
      this.savingFlag = false;
      if (this.saveCallback) {
        this.saveCallback.emit();
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  cancel() {
    if (this.cancelCallback) {
      this.cancelCallback.emit();
    }
  }

}
